import React, {useMemo} from "react";

import {CustomBlending, MaxEquation, OneFactor, Texture} from "three";

// Import the raw GLSL code from the files
import fragmentShader from "./hueShift.frag?raw";
import vertexShader from "./hueShift.vert?raw";

interface HueShiftMaterialProps {
  map: Texture;
}

const HueShiftMaterial: React.FC<HueShiftMaterialProps> = ({map}) => {
  // Memoize the uniforms object to prevent it from being recreated on every render,
  // which is important for performance with shader materials.
  // This is a lightweight version of what your `useUniforms` hook likely does.
  const uniforms = useMemo(
    () => ({
      map: {value: map},
    }),
    [map],
  );

  return (
    <shaderMaterial
      attach="material"
      vertexShader={vertexShader}
      fragmentShader={fragmentShader}
      uniforms={uniforms}
      vertexColors
      blending={CustomBlending}
      depthWrite={false}
      transparent={true}
      blendSrc={OneFactor}
      blendDst={OneFactor}
      blendEquation={MaxEquation}
    />
  );
};

export default HueShiftMaterial;
